import React from "react";

export const I18nContext = React.createContext({});

export default ({ translations, children }) => (
  <I18nContext.Provider value={translations}>{children}</I18nContext.Provider>
);
